import './ProjectShowcase.css'
import ShowcaseDesc from './DescriptionShowcase';

function ShowcaseEmbed({
    children,
    Title = 'Unnamed Project',
    Date = 'Today',
    EmbedCode =(<p>No Embed Found</p>),
    EmbedSrc="",
    EmbedLink="",
    EmbedAuthorText="",
    ButtonURL="",
    ButtonText="Play",
    EmbedOnLeft = false
}) {
    let embed = (
        <></>
    );
    if (EmbedSrc) {
        embed = (
            <div className='ShowcaseImage'>
            <iframe title={Title} frameBorder="0" src={EmbedSrc} width="552" height="167">
                { EmbedLink && EmbedAuthorText &&
                    <a href={EmbedLink}>{EmbedAuthorText}</a>
                }
            </iframe>
            </div>
        );
    }
    else {
        embed = (
            <div className='ShowcaseImage'>
                {EmbedCode}
            </div>
        )
    }
    let content = (
        <div className='ShowcaseContent'>
            <ShowcaseDesc
                Title={Title}
                Date={Date}
                ButtonURL={ButtonURL}
                ButtonText={ButtonText}
            >
                {children}
            </ShowcaseDesc>
        </div>
    );

    if (EmbedOnLeft) {
            content = (
                <>
                    {embed}
                    {content}
                </>
            );
        }
        else {
            content = (
                <>
                    {content}
                    {embed}
                </>
            );
        }
    
    return(
        <div className="Showcase">
            {content}
        </div>
    );
}

export default ShowcaseEmbed;